// extracted by mini-css-extract-plugin
module.exports = {"grid":"JobOfferListPage_grid__FcOEd","gridItem":"JobOfferListPage_gridItem__2uXZO"};